import React, { useEffect, useState, useRef } from 'react';
import aboutSection5 from '../../assets/images/about/about_section_5.png';

function AboutSection5() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05, // 섹션이 30% 이상 보일 때 트리거
        rootMargin: '-20px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="md:h-[647px] w-full flex justify-center bg-[#FDF4FF] py-[60px] md:py-0">
      <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between">
        {/* 왼쪽 이미지 */}
        <div
          className={`w-full md:w-1/2 flex justify-center md:justify-end h-full mb-[10px] md:mb-0 mt-[10px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`}
        >
          <img
            src={aboutSection5}
            alt="안경점 지도"
            className="w-full md:w-[700px] h-[370px] md:h-[647px] object-cover"
          />
        </div>
        {/* 오른쪽 텍스트 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start pt-8 md:pt-0 px-4 md:px-[80px] space-y-[16px] md:space-y-[50px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`}
        >
          <div className="text-[#A019B2] text-[18px] md:text-[24px] leading-[160%] font-pretendard font-normal text-center md:text-left mb-4 md:mb-0">
            오프라인 안경점 수령
          </div>
          <h2 className="text-[24px] md:text-[40px] leading-[140%] font-pretendard font-bold text-black text-center md:text-left">
            <span className="block md:hidden">
              구매한 렌즈<br />전국 600여 개<br />제휴 안경점에서 수령
            </span>
            <span className="hidden md:block">
              구매한 렌즈<br />전국 600여 개 제휴 안경점에서 수령
            </span>
          </h2>
          <p className="text-[16px] md:text-[20px] leading-[160%] font-pretendard font-normal text-black text-center md:text-left">
            도수를 확인하고, 안경사의 전문 상담을 통해<br />더 정확하고 신뢰할 수 있는 경험을 제공합니다.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutSection5; 